import React, { useEffect, useState } from 'react';
import FalconComponentCard from 'components/common/FalconComponentCard';
import firebase from './../../../firebase';
import { useParams } from 'react-router-dom';
import { Modal, Button, Col, Form, Row } from 'react-bootstrap';
import Select from 'react-select';
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import CustomDateInput from 'components/common/CustomDateInput';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import fr from 'date-fns/locale/fr';
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import IconButton from 'components/common/IconButton';
import { useFormatDate } from 'hooks'; 
import Flex from 'components/common/Flex';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import jsPDF from "jspdf";
import "jspdf-autotable";
import Newucrm from '../crm/New';
import logoIcon from 'assets/img/logoIcon.png';
import logoText from 'assets/img/BoHouse.png';



// Générer la date actuelle au format "Saint-Tropez, le 15 JUILLET 2024"
const getFormattedDate = () => {
  const today = new Date();
  const options = { day: "2-digit", month: "long", year: "numeric" };
  const formattedDate = today.toLocaleDateString("fr-FR", options).toUpperCase();
  return `Saint-Tropez, le ${formattedDate}`;
};

const EditBooking = () => {
  const { id } = useParams();
  registerLocale('fr', fr);
  setDefaultLocale('fr');
  const [showModal, setShowModal] = useState(false);
  const [valueClientId, setValueClientId] = React.useState(null);
  const [valueVilla, setValueVilla] = React.useState(null);
  const [valueStatut, setValueStatut] = React.useState(null);
  const [valueOrigin, setValueOrigin] = React.useState(null);
  const [validated, setValidated] = React.useState(false);
  const [valueListDemande, setValueListDemande] = React.useState([]);
  const [valueDemande, setValueDemande] = React.useState(null);
  const [formd, setFrom] = React.useState({});
  const [l, setL] = React.useState(false);
  const [is_moral, setMoral] = React.useState(false);
  const [is_owner, setIs_Owner] = React.useState(false);
  const [clients, setClients] = React.useState([]);
  const [checkIn, setCheckIn] = React.useState(new Date());
  const [checkOut, setCheckOut] = React.useState(new Date());
  const [demand_date, setDemand_Date] = React.useState(new Date());
  const [booked_date, setBooked_Date] = React.useState(new Date());
  const [emails, setEmails] = React.useState('');
  const [disabledClientId, setDisableclientId] = React.useState(false);
  const [logs, setLogs] = React.useState([]);
  const [questions, setQuestions] = React.useState([]);
  const [menages, setMenages] = React.useState([]);
  const [villas, setVilla] = React.useState([]);
  const [clientIsMoral, setClientIsMoral] = React.useState(false);
  const [propertyIsMoral, setPropertyIsMoral] = React.useState(false);

  const navigate = useNavigate();

  function isValid(value) {
    if (!value) return false; // Valeur nulle ou indéfinie

    const number = parseFloat(value);
    if (isNaN(number)) return false;
    if (number == 0) return false;
    return true
  }

  function formatCurrency(value) {
    if (!value) return "0,00 €";

    // Si la valeur contient déjà une virgule, remplacer par un point pour le parsing
    const numberStr = value.toString().replace(',', '.');
    const number = parseFloat(numberStr);
    if (isNaN(number)) return "0,00 €";

    // Arrondir à 2 décimales pour éviter les erreurs de calcul flottant
    const roundedNumber = Math.round(number * 100) / 100;
    
    // Séparer la partie entière et décimale
    const parts = roundedNumber.toString().split('.');
    const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    const decimalPart = parts[1] ? parts[1].padEnd(2, '0') : '00';

    return `${integerPart},${decimalPart} €`;
  }
  const formatVAT = (amount) => { 
    if (!amount ) return '';

    // Si la valeur contient déjà une virgule, remplacer par un point pour le parsing
    const numberStr = amount.toString().replace(',', '.');
    const number = parseFloat(numberStr);
    if (isNaN(number)) return '';

    // Calculer la TVA de 20%
    const vat = number * 0.20;
    
    // Utiliser la fonction formatCurrency mise à jour
    console.log("vat", vat)
    return formatCurrency(vat.toString());
  };

  const formatCurrencyWithVAT = (amount) => {
    if (!amount) return '';

    // Si la valeur contient déjà une virgule, remplacer par un point pour le parsing
    const numberStr = amount.toString().replace(',', '.');
    const number = parseFloat(numberStr);
    if (isNaN(number)) return '';

    // Calculer le montant avec TVA
    const amountWithVAT = number * 1.20;
    
    // Utiliser la fonction formatCurrency mise à jour
    return formatCurrency(amountWithVAT.toString());
  };


  function formatDateRange(checkin, checkout) {
    // Tableaux pour les noms des mois
    const mois = [
      "JANVIER", "FÉVRIER", "MARS", "AVRIL", "MAI", "JUIN",
      "JUILLET", "AOÛT", "SEPTEMBRE", "OCTOBRE", "NOVEMBRE", "DÉCEMBRE"
    ];

    // Conversion des dates en objets Date
    const dateCheckin = checkin?.seconds ? new Date(checkin?.toDate()) : checkin;
    const dateCheckout = checkout?.seconds ? new Date(checkout?.toDate()) : checkout;

    // Extraction des jours et des mois
    const jourCheckin = dateCheckin.getDate();
    const moisCheckin = mois[dateCheckin.getMonth()];
    const anneeCheckin = dateCheckin.getFullYear();

    const jourCheckout = dateCheckout.getDate();
    const moisCheckout = mois[dateCheckout.getMonth()];
    const anneeCheckout = dateCheckout.getFullYear();

    // Génération du texte au format demandé
    if (anneeCheckin === anneeCheckout && moisCheckin === moisCheckout) {
      return `${jourCheckin} au ${jourCheckout} ${moisCheckin} ${anneeCheckin}`;
    } else if (anneeCheckin === anneeCheckout) {
      return `${jourCheckin} ${moisCheckin} au ${jourCheckout} ${moisCheckout} ${anneeCheckin}`;
    } else {
      return `${jourCheckin} ${moisCheckin} ${anneeCheckin} au ${jourCheckout} ${moisCheckout} ${anneeCheckout}`;
    }
  }

  const formatDateRangeEN = (startDate, endDate) => {
    if (!startDate || !endDate) return "";

    // Convertir les dates en objets Date
    const start = startDate?.seconds ? new Date(startDate?.toDate()) : startDate;
    const end = endDate?.seconds ? new Date(endDate?.toDate()) : endDate;

    // Récupérer les noms des mois en anglais
    const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

    // Format des dates en anglais
    const startMonth = monthNames[start.getMonth()];
    const endMonth = monthNames[end.getMonth()];

    const startDay = start.getDate();
    const endDay = end.getDate();
    const year = start.getFullYear();

    // Gérer les cas où le mois et l'année sont les mêmes
    if (startMonth === endMonth && start.getFullYear() === end.getFullYear()) {
      return `Rental From ${startMonth} ${startDay} to ${endDay}, ${year}`;
    }

    // Si le mois ou l'année change, on affiche les deux mois/années
    return `Rental From ${startMonth} ${startDay} to ${endMonth} ${endDay}, ${year}`;
  };

  const sendQuestionnaireEmail = async (bookingId) => {
    setL(true)
    try {
      const sendQuestionnaireFunction = firebase.functions().httpsCallable('sendQuestionnaireId');
      const result = await sendQuestionnaireFunction({ id: bookingId });
      
      if (result.data.success) {
        toast.success('Questionnaire envoyé avec succès');
      }
    } catch (error) {
      console.error('Erreur lors de l\'envoi du questionnaire:', error);
      toast.error('Erreur lors de l\'envoi du questionnaire');
    }finally{
      setL(false)
    }
  };

  const generatePDFcall_for_funds = () => {

    toast.warning("Pensez a sauvegarder vos données avant de generer le document", { autoClose: 3000 });

    const foundClient = clients.find((c) => c.value === formd.client?.value);
     

const client = Array.isArray(foundClient?.data?.companies) && foundClient.data.companies.length > 0
  ? foundClient.data.companies[0]
  : formd.client.data || foundClient?.data || formd.client;
 

  const property = villas.find((p) => p.value === formd.property?.value)?.data || formd.property;

    let type = property.type?.label?.toUpperCase() || "VILLA";
    // console.log("type", type);
    // console.log('property', property)
    // console.log('client', client)
    // return ;

    const doc = new jsPDF();

    // Ajouter le logo

    doc.addImage(logoIcon, "PNG", 10, 10, 20, 20);
    // En-tête de l'émetteur (avec du gras)
    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    doc.text("BAT 4 Rue parc les LICES", 10, 40);
    doc.setFont("helvetica", "normal");
    doc.text("Traverse de la Matelotte, 83990 SAINT TROPEZ", 10, 45);
    doc.text("N° SIREN Saint-Tropez : 828 073 593", 10, 50);
    doc.text("Mobile: 06 08 84 83 54 / 06 22 68 24 20", 10, 55);
    doc.setFont("helvetica", "bold");
    doc.text("karine@bo-house.com", 10, 60);
    doc.setFont("helvetica", "normal");

    // Informations du client
    const clientX = 140; // Position à droite
    // doc.text("Mr Jose Ermirio Moraes FILHO", clientX, 40);
    // doc.text("R.AMAURI 225-16 Andar", clientX, 45);
    // doc.text("SAO PAULO SP-01448-000", clientX, 50);
    // doc.text("BRESIL", clientX, 55);
    console.log('clientIsMoral', clientIsMoral)
    if (clientIsMoral) {

    
        doc.text(`${client?.businessName}`, clientX, 40);
        doc.text(client?.businessAdresse || "", clientX, 45);
        doc.text(`${client?.businessCity || ""} ${client?.businessZipcode || ""}`, clientX, 50);
        doc.text(client?.businessCountry || "", clientX, 55);
      

      
    } else {
      doc.text(`${client?.lastName} ${client?.firstName}`, clientX, 40);
      doc.text(client?.adresse || "", clientX, 45);
      doc.text(`${client?.city || ""} ${client?.zipcode || ""}`, clientX, 50);
      doc.text(client?.country || "", clientX, 55);
    }



    // Date générée
    doc.text(getFormattedDate(), clientX, 65);

    // Titre principal centré en gras
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.text("APPEL DE FONDS / NATURE OF SERVICES", 105, 80, null, null, "center");
    doc.setFont("helvetica", "normal");


    const calculateTotal = () => {
      // Conversion des valeurs texte en nombres en préservant les décimales
      const { rent = "0", cleaningStay = "0", exitCleaning = "0", baififf = "0", security = "0", acompte = "0" } = formd;
      
      // Fonction pour convertir en nombre en préservant les décimales
      const parseAmount = (value) => {
        if (!value) return 0;
        // Remplace la virgule par un point pour le parsing
        const numberStr = value.toString().replace(',', '.');
        return parseFloat(numberStr);
      };

      // Calcul du total en préservant les décimales
      let total = parseAmount(rent) +
        parseAmount(cleaningStay) +
        parseAmount(exitCleaning) +
        parseAmount(baififf) +
        parseAmount(security);
      
      let acm = parseAmount(acompte);
      if (!isNaN(acm)) {
        total -= acm;
      }

      return formatCurrency(total.toString());
    };

    const formatDateFR = (date) => {
      if (!date) return "";

      const monthNames = [
        "janvier", "février", "mars", "avril", "mai", "juin",
        "juillet", "août", "septembre", "octobre", "novembre", "décembre"
      ];

      const d = date?.seconds ? new Date(date?.toDate()) : date;
      const day = d.getDate();
      const month = monthNames[d.getMonth()];
      const year = d.getFullYear();

      return `${day} ${month.toUpperCase()} ${year}`;
    };

    const formatDateEN = (date) => {
      if (!date) return "";

      const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ];

      const d = date?.seconds ? new Date(date?.toDate()) : new Date();
      const day = d.getDate();
      const month = monthNames[d.getMonth()];
      const year = d.getFullYear();

      return `${month} ${day}, ${year}`;
    };


    // Tableau des services
    const tableStartY = 90;
    const tableHead = [["DESIGNATION/ PARTICULARS", "QTE", "PRIX UNITAIRE", "TOTAL"]];
    let tableBody = [
      ["SOLDE LOYER LOCATION " + type + " " + property?.nameHouse,
      { content: "1", styles: { halign: "center" } },
      { content: formatCurrency(formd?.rent), styles: { halign: "center" } },
      { content: formatCurrency(formd?.rent), styles: { halign: "center" } }
      ],
      [{ content: "BALANCE OF RENTAL PAYMENT " + type + " " + property?.nameHouse, styles: { fontStyle: 'italic' } }, "", "", ""],
      ["Adresse: " + property?.adresse + ", " + property?.zipcode + " " + property?.city, "", "", ""]
    ]
    if (isValid(formd?.acompte)) {
      tableBody.push(["ACOMPTE ",
        { content: "1", styles: { halign: "center" } },
        { content: "- " + formatCurrency(formd?.acompte), styles: { halign: "center" } },
        { content: "- " + formatCurrency(formd?.acompte), styles: { halign: "center" } }
      ]
      )
    }
    if (isValid(formd?.cleaningStay)) {
      tableBody.push(["MENAGE PENDANT SEJOUR / extra cleaning",
        { content: "1", styles: { halign: "center" } },
        { content: formatCurrency(formd?.cleaningStay), styles: { halign: "center" } },
        { content: formatCurrency(formd?.cleaningStay), styles: { halign: "center" } }
      ])
    }
    if (isValid(formd?.exitCleaning)) {
      tableBody.push([{ content: "MENAGE DE SORTIE / End of stay cleaning", styles: { fontStyle: 'italic' } },
      { content: "1", styles: { halign: "center" } },
      { content: formatCurrency(formd?.exitCleaning), styles: { halign: "center" } },
      { content: formatCurrency(formd?.exitCleaning), styles: { halign: "center" } }
      ])
    }

    if (isValid(formd?.baififf)) {
      tableBody.push(["BAILIFF",
        { content: "1", styles: { halign: "center" } },
        { content: formatCurrency(formd?.baififf), styles: { halign: "center" } },
        { content: formatCurrency(formd?.baififf), styles: { halign: "center" } }
      ])
    }
    if (isValid(formd?.security)) {
      tableBody.push(["Caution Remboursable", { content: "1", styles: { halign: "center" } }, { content: formatCurrency(formd?.security), styles: { halign: "center" } }, { content: formatCurrency(formd?.security), styles: { halign: "center" } }],
      )
    }

    tableBody.push([`Location du ${formatDateRange(formd.checkin, formd.checkout)}`, "", "", ""]);

    tableBody.push([{ content: formatDateRangeEN(formd.checkin, formd.checkout), styles: { fontStyle: 'italic' } }, "", "", ""]);
    tableBody.push([`En accord avec le contrat de location du ${formatDateFR(formd?.booked_date)}`, "", "", ""]);
    tableBody.push([{ content: `According to Rental contract signed on ${formatDateEN(formd?.booked_date)}`, styles: { fontStyle: 'italic' } }, "", "", ""]);
    tableBody.push([{ content: "", colSpan: 2, rowSpan: 2, styles: { fillColor: [255, 255, 255] } }, { content: "TOTAL:", styles: { fontStyle: 'bold' } }, { content: calculateTotal(), rowSpan: 2, styles: { fillColor: [222, 207, 200], halign: "center" } }]);
    tableBody.push([{ content: "NET A PAYER EN EUROS", styles: { textColor: [255, 0, 0] } }]);


    doc.autoTable({
      startY: tableStartY,
      head: tableHead,
      body: tableBody,
      styles: {
        fontSize: 8,
        halign: "left", // Texte aligné à gauche dans le tableau
        valign: "middle",
        cellPadding: 1,
        lineWidth: 0.1, // Largeur de la bordure
        lineColor: [0, 0, 0], // Couleur de la bordure (noir)
      },
      bodyStyles: {
        lineWidth: 0.1, // Largeur de la bordure des cellules
        lineColor: [0, 0, 0], // Couleur de la bordure (noir)
      },
      headStyles: {
        fillColor: [222, 207, 200],
        textColor: [0, 0, 0],
        fontStyle: "bold",
        halign: "center", // En-tête centré
      },
      alternateRowStyles: {
        fillColor: [240, 240, 240], // Gris clair pour alternance
      },

    });

    // Total général
    const totalY = doc.previousAutoTable.finalY + 10;
    doc.setFontSize(10);
    doc.text("En votre aimable règlement", 10, totalY + 10);
    doc.text("Releve d'identité bancaire (RIB) ", 10, totalY + 20);
    // doc.setFontSize(12);
    // doc.text("TOTAL : 66430,00 €", 10, totalY); 
    doc.autoTable({
      startY: totalY + 25, // Position de départ pour le tableau
      head: [["Banque", "Guichet", "Compte", "Cle RIB"]],
      body: [
        ["18315", "10000", "8008317976", "70"],
        [{ content: "IBAN", colSpan: 3, styles: { fontStyle: 'bold' } }, { content: "BIC", styles: { fontStyle: 'bold' } }],
        [{ content: "FR7618315100000800831797670", colSpan: 3 }, "CEPAFRPP831"],
        [{ content: "Adresse", styles: { fontStyle: 'bold' } }],
        [{ content: "Place du 15 eme Corps", styles: { halign: "left", cellPadding: 0 }, colSpan: 4 }],
        [{ content: "Avenue Augustin Grangeon", styles: { halign: "left", cellPadding: 0 }, colSpan: 4 }],
        [{ content: "83990 Saint-Tropez", styles: { halign: "left", cellPadding: 0 }, colSpan: 4 }],
      ],
      styles: {
        fontSize: 10,
        halign: "center", // Alignement du texte à gauche dans les cellules
        valign: "middle", // Alignement vertical au centre
        cellPadding: 1,
        fillColor: [255, 255, 255],
      },
      headStyles: {
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0], // Couleur du texte de l'en-tête (blanc)
        fontStyle: "bold", // En-tête en gras
        halign: "center", // Texte centré dans l'en-tête
      },

      alternateRowStyles: {
        fillColor: [255, 255, 255],  // Blanc pour alternance
      },
      tableWidth: 100,
      margin: { top: 20 }, // Espacement du haut si nécessaire
    });

    // Informations bancaires
    // const bankInfoY = totalY + 10;


    // Sauvegarder le fichier PDF
    doc.save("call_for_funds.pdf");
  };

  const generatePDFcall_for_funds_ACOMPTE = () => {

    toast.warning("Pensez a sauvegarder vos données avant de generer le document", { autoClose: 3000 });

    const client = clients.find((c) => c.value === formd.client?.value)?.data?.companies || formd.client;
    const property = villas.find((p) => p.value === formd.property?.value)?.data || formd.property;

    let type = property.type?.label?.toUpperCase() || "VILLA";
    // console.log("type", type);
    // console.log('property', property)
    // console.log('client', client)
    // return ;

    const doc = new jsPDF();

    // Ajouter le logo 
    // Dimensions de la page
    const pageWidth = doc.internal.pageSize.getWidth();

    // Dimensions de l'image
    const imageWidth = 20; // largeur de votre image en unités jsPDF
    const imageHeight = 20; // hauteur de votre image en unités jsPDF

    // Calcul de la position horizontale pour centrer
    const xPosition = (pageWidth - imageWidth) / 2;

    // Ajouter l'image centrée 
    doc.addImage(logoIcon, "PNG", xPosition, 10, imageWidth, imageHeight);

    // En-tête de l'émetteur (avec du gras)
    doc.setFontSize(14);
    doc.setFont("helvetica", "bold");
    doc.text("BO HOUSE", 10, 35);
    doc.setFontSize(10);
    doc.text("BAT 4 Rue parc les LICES", 10, 40);
    doc.setFont("helvetica", "normal");
    doc.text("Traverse de la Matelotte, 83990 SAINT TROPEZ", 10, 45);
    doc.text("N° SIREN Saint-Tropez : 828 073 593", 10, 50);
    doc.text("Mobile: 06 08 84 83 54 / 06 22 68 24 20", 10, 55);
    doc.setFont("helvetica", "bold");
    doc.text("karine@bo-house.com", 10, 60);
    doc.setFont("helvetica", "normal");

    // Informations du client
    const clientX = 140; // Position à droite
    // doc.text("Mr Jose Ermirio Moraes FILHO", clientX, 40);
    // doc.text("R.AMAURI 225-16 Andar", clientX, 45);
    // doc.text("SAO PAULO SP-01448-000", clientX, 50);
    // doc.text("BRESIL", clientX, 55);



    if (clientIsMoral) {
      doc.text(`${client?.businessName}`, clientX, 40);
      doc.text(client?.businessAdresse || "", clientX, 45);
      doc.text(`${client?.businessCity || ""} ${client?.zipcode || ""}`, clientX, 50);
      doc.text(client?.businessCountry || "", clientX, 55);
    } else {
      doc.text(`${client?.lastName} ${client?.firstName}`, clientX, 40);
      doc.text(client?.adresse || "", clientX, 45);
      doc.text(`${client?.city || ""} ${client?.zipcode || ""}`, clientX, 50);
      doc.text(client?.country || "", clientX, 55);
    }

    // Date générée
    doc.text(getFormattedDate(), clientX, 65);

    // Titre principal centré en gras
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.text("APPEL DE FONDS / NATURE OF SERVICES", 105, 80, null, null, "center");
    doc.setFont("helvetica", "normal");



    const formatDateFR = (date) => {
      if (!date) return "";

      const monthNames = [
        "janvier", "février", "mars", "avril", "mai", "juin",
        "juillet", "août", "septembre", "octobre", "novembre", "décembre"
      ];

      const d = date?.seconds ? new Date(date?.toDate()) : date;
      const day = d.getDate();
      const month = monthNames[d.getMonth()];
      const year = d.getFullYear();

      return `${day} ${month.toUpperCase()} ${year}`;
    };

    const formatDateEN = (date) => {
      if (!date) return "";

      const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ];

      const d = date?.seconds ? new Date(date?.toDate()) : new Date();
      const day = d.getDate();
      const month = monthNames[d.getMonth()];
      const year = d.getFullYear();

      return `${month} ${day}, ${year}`;
    };


    // Tableau des services
    const tableStartY = 90;
    const tableHead = [["DESIGNATION/ PARTICULARS", "QTE", "PRIX UNITAIRE", "TOTAL"]];
    const tableBody = [
      ["ACOMPTE LOYER LOCATION " + type + " " + property?.nameHouse,
      { content: "1", styles: { halign: "center" } },
      { content: formatCurrency(formd?.acompte), styles: { halign: "center" } },
      { content: formatCurrency(formd?.acompte), styles: { halign: "center" } }
      ],
      [`Location du ${formatDateRange(formd.checkin, formd.checkout)}`, "", "", ""],
      [{ content: formatDateRangeEN(formd.checkin, formd.checkout), styles: { fontStyle: 'italic' } }, "", "", ""],
      [`En accord avec le contrat de location du ${formatDateFR(formd?.booked_date)}`, "", "", ""],
      [{ content: `According to Rental contract signed on ${formatDateEN(formd?.booked_date)}`, styles: { fontStyle: 'italic' } }, "", "", ""],
      [{ content: "", colSpan: 2, rowSpan: 2 }, { content: "TOTAL:", styles: { fontStyle: 'bold' } }, { content: formatCurrency(formd?.acompte), rowSpan: 2, styles: { fillColor: [222, 207, 200], halign: "center" } }],
      [{ content: "NET A PAYER EN EUROS", styles: { textColor: [255, 0, 0] } }],
    ];

    doc.autoTable({
      startY: tableStartY,
      head: tableHead,
      body: tableBody,
      styles: {
        fontSize: 8,
        halign: "left", // Texte aligné à gauche dans le tableau
        valign: "middle",
        cellPadding: 1,
        lineWidth: 0.1, // Largeur de la bordure
        lineColor: [0, 0, 0], // Couleur de la bordure (noir)
      },
      bodyStyles: {
        lineWidth: 0.1, // Largeur de la bordure des cellules
        lineColor: [0, 0, 0], // Couleur de la bordure (noir)
      },
      headStyles: {
        fillColor: [222, 207, 200],
        textColor: [0, 0, 0],
        fontStyle: "bold",
        halign: "center", // En-tête centré
      },
      alternateRowStyles: {
        fillColor: [240, 240, 240], // Gris clair pour alternance
      },

    });

    // Total général
    const totalY = doc.previousAutoTable.finalY + 10;
    doc.setFontSize(10);
    doc.text("En votre aimable règlement", 10, totalY + 10);
    doc.text("Releve d'identité bancaire (RIB) ", 10, totalY + 20);
    // doc.setFontSize(12);
    // doc.text("TOTAL : 66430,00 €", 10, totalY); 
    doc.autoTable({
      startY: totalY + 25, // Position de départ pour le tableau
      head: [["Banque", "Guichet", "Compte", "Cle RIB"]],
      body: [
        ["18315", "10000", "8008317976", "70"],
        [{ content: "IBAN", colSpan: 3, styles: { fontStyle: 'bold' } }, { content: "BIC", styles: { fontStyle: 'bold' } }],
        [{ content: "FR7618315100000800831797670", colSpan: 3 }, "CEPAFRPP831"],
        [{ content: "Adresse", styles: { fontStyle: 'bold' } }],
        [{ content: "Place du 15 eme Corps", styles: { halign: "left", cellPadding: 0 }, colSpan: 4 }],
        [{ content: "Avenue Augustin Grangeon", styles: { halign: "left", cellPadding: 0 }, colSpan: 4 }],
        [{ content: "83990 Saint-Tropez", styles: { halign: "left", cellPadding: 0 }, colSpan: 4 }],
      ],
      styles: {
        fontSize: 10,
        halign: "center", // Alignement du texte à gauche dans les cellules
        valign: "middle", // Alignement vertical au centre
        cellPadding: 1,
        fillColor: [255, 255, 255],
      },
      headStyles: {
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0], // Couleur du texte de l'en-tête (blanc)
        fontStyle: "bold", // En-tête en gras
        halign: "center", // Texte centré dans l'en-tête
      },

      alternateRowStyles: {
        fillColor: [255, 255, 255],  // Blanc pour alternance
      },
      tableWidth: 100,
      margin: { top: 20 }, // Espacement du haut si nécessaire
    });

    // Informations bancaires
    // const bankInfoY = totalY + 10;
    const pageHeight = doc.internal.pageSize.getHeight();
    doc.addImage(logoText, "PNG", xPosition, pageHeight - 10, imageWidth, 3);
    // Sauvegarder le fichier PDF
    doc.save("call_for_funds acompte.pdf");
  };

  const generatePDFInvoice = () => {


    toast.warning("Pensez a sauvegarder vos données avant de generer le document", { autoClose: 3000 });
    const foundClient = clients.find((c) => c.value === formd.client?.value);
const client = Array.isArray(foundClient?.data?.companies) && foundClient.data.companies.length > 0
  ? foundClient.data.companies[0]
  : formd.client.data || foundClient?.data || formd.client;
  const property = villas.find((p) => p.value === formd.property?.value)?.data || formd.property;

    let type = property.type?.label?.toUpperCase() || "VILLA";
    // let ownerId = property?.ownerId
    let owner = clients.find((c) => c.value === property?.ownerId)?.data || {};
    // console.log("owner" , owner)
    const doc = new jsPDF();

    // Ajouter le logo

    doc.addImage(logoIcon, "PNG", 10, 10, 20, 20);
    // En-tête de l'émetteur (avec du gras)
    doc.setFontSize(10);
    // doc.text("Quartier des Conquettes, 417 Avenue Paul Roussel", 10, 40);
    doc.setFont("helvetica", "normal");
    doc.text("Quartier des Conquettes, 417 Avenue Paul Roussel", 10, 40);
    doc.text("N° SIREN Saint-Tropez : 828 073 593", 10, 45);
    doc.text("Mobile: 06 08 84 83 54 / 06 22 68 24 20", 10, 50);
    doc.setFont("helvetica", "bold");
    doc.text("karine@bo-house.com", 10, 55);
    doc.setFont("helvetica", "normal");

    // Informations du client
    const clientX = 140; // Position à droite 

    if (propertyIsMoral) {
      const data = clients.find((c) => c.value === villas.find(s => s.value === formd.property.value).data.ownerId).data
 
      if (data.companies && data.companies.length > 0){
        data.companies.forEach((company, index) => {
          if (company.property) {
            company.property.forEach((prop, index) => {
              if (prop.value === formd.property?.value) {
                doc.text(`${company?.businessName}`, clientX, 40);
                doc.text(company?.businessAdresse || "", clientX, 45);
                doc.text(`${company?.businessCity || ""} ${company?.businessZipcode || ""}`, clientX, 50);
                doc.text(company?.businessCountry || "", clientX, 55);
              }
            })
          }
        })
      }else{
        
        doc.text(`${data.businessName}`, clientX, 40);
        doc.text(data?.businessAdresse || "", clientX, 45);
        doc.text(`${data?.businessCity} ${owner?.businessZipcode}`, clientX, 50);
      }







    } else {
      doc.text(`${owner?.lastName} ${owner?.firstName}`, clientX, 40);
      doc.text(owner?.adresse || "", clientX, 45);
      doc.text(`${owner?.city} ${owner?.zipcode}`, clientX, 50);
    }



    // doc.text("BRESIL", clientX, 55);

    // Date générée
    doc.text(getFormattedDate(), clientX, 65);

    // Titre principal centré en gras
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.text("FACTURE N° " + formd?.numberInvoice, 105, 80, null, null, "center");
    doc.setFont("helvetica", "normal");

    // Tableau des services
    const tableStartY = 90;
    const tableHead = [["DESIGNATION", "QTE", "PRIX UNITAIRE HT", "TOTAL HT"]];
    const tableBody = [
      [{ content: `FRAIS AGENCE BO HOUSE\nLocation Mme ${client.lastName}\n${formatDateRange(formd.checkin, formd.checkout)}\n${type} ${property.nameHouse}\n(${property?.adresse + ", " + property?.zipcode + " " + property?.city})` }, { content: "1", styles: { halign: "center" } }, { content: formatCurrency(formd?.agencefee), styles: { halign: "center" } }, { content: formatCurrency(formd?.agencefee), styles: { halign: "center" } }],

      [{ content: "", colSpan: 2, rowSpan: 4 }, { content: "TOTAL HT", }, { content: formatCurrency(formd?.agencefee), styles: { halign: "center" } }],  // Ajout de la ligne pour le total général
      [{ content: "TVA 20 % ", }, { content: formatVAT(formd?.agencefee), styles: { halign: "center" } }],  // Ajout de la ligne pour le total général
      [{ content: "TOTAL TTC*", styles: { fontStyle: 'bold' } }, { content: formatCurrencyWithVAT(formd?.agencefee), rowSpan: 2, styles: { fillColor: [222, 207, 200], halign: "center" } }],  // Ajout de la ligne pour le total général
      [{ content: "NET A PAYER EN EUROS", styles: { textColor: [255, 0, 0], fontStyle: 'bold' } }],  // Ajout de la ligne pour le total général
    ];


    doc.autoTable({
      startY: tableStartY,
      head: tableHead,
      body: tableBody,
      styles: {
        fontSize: 8,
        halign: "left", // Texte aligné à gauche dans le tableau
        valign: "middle",
        cellPadding: 1,
        lineWidth: 0.1, // Largeur de la bordure
        lineColor: [0, 0, 0], // Couleur de la bordure (noir)
      },
      bodyStyles: {
        lineWidth: 0.1, // Largeur de la bordure des cellules
        lineColor: [0, 0, 0], // Couleur de la bordure (noir)
      },
      headStyles: {
        fillColor: [222, 207, 200],
        textColor: [0, 0, 0],
        fontStyle: "bold",
        halign: "center", // En-tête centré
      },
      alternateRowStyles: {
        fillColor: [240, 240, 240], // Gris clair pour alternance
      },

    });

    // Total général
    const totalY = doc.previousAutoTable.finalY + 10;
    doc.setFontSize(10);
    doc.text("En votre aimable règlement", 10, totalY + 10);
    doc.text("Releve d'identité bancaire (RIB) ", 10, totalY + 20);
    // doc.setFontSize(12);
    // doc.text("TOTAL : 66430,00 €", 10, totalY); 
    doc.autoTable({
      startY: totalY + 25, // Position de départ pour le tableau
      head: [["Banque", "Guichet", "Compte", "Cle RIB"]],
      body: [
        ["18315", "10000", "8008317976", "70"],
        [{ content: "IBAN", colSpan: 3, styles: { fontStyle: 'bold' } }, { content: "BIC", styles: { fontStyle: 'bold' } }],
        [{ content: "FR7618315100000800831797670", colSpan: 3 }, "CEPAFRPP831"],
        [{ content: "Adresse", styles: { fontStyle: 'bold' } }],
        [{ content: "Place du 15 eme Corps", styles: { halign: "left", cellPadding: 0 }, colSpan: 4 }],
        [{ content: "Avenue Augustin Grangeon", styles: { halign: "left", cellPadding: 0 }, colSpan: 4 }],
        [{ content: "83990 Saint-Tropez", styles: { halign: "left", cellPadding: 0 }, colSpan: 4 }],
      ],
      styles: {
        fontSize: 10,
        halign: "center", // Alignement du texte à gauche dans les cellules
        valign: "middle", // Alignement vertical au centre
        cellPadding: 1,
        fillColor: [255, 255, 255],
      },
      headStyles: {
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0], // Couleur du texte de l'en-tête (blanc)
        fontStyle: "bold", // En-tête en gras
        halign: "center", // Texte centré dans l'en-tête
      },

      alternateRowStyles: {
        fillColor: [255, 255, 255],  // Blanc pour alternance
      },
      tableWidth: 100,
      margin: { top: 20 }, // Espacement du haut si nécessaire
    });

    // Informations bancaires
    // const bankInfoY = totalY + 10;


    // Sauvegarder le fichier PDF
    doc.save("facture 0824333.pdf");
  };
  const generatePDFQuittance = () => {

    toast.warning("Pensez a sauvegarder vos données avant de generer le document", { autoClose: 3000 });

    const foundClient = clients.find((c) => c.value === formd.client?.value);
const client = Array.isArray(foundClient?.data?.companies) && foundClient.data.companies.length > 0
  ? foundClient.data.companies[0]
  : formd.client.data || foundClient?.data || formd.client;
  const property = villas.find((p) => p.value === formd.property?.value)?.data || formd.property;

    let type = property.type?.label?.toUpperCase() || "VILLA";

    const doc = new jsPDF();

    // Ajouter le logo

    doc.addImage(logoIcon, "PNG", 10, 10, 20, 20);
    // En-tête de l'émetteur (avec du gras)
    doc.setFontSize(10);
    doc.text("BAT 4 Rue parc les LICES", 10, 40);
    doc.setFont("helvetica", "normal");
    doc.text("Traverse de la Matelotte, 83990 SAINT TROPEZ", 10, 45);
    doc.text("N° SIREN Saint-Tropez : 828 073 593", 10, 50);
    doc.text("Mobile: 06 08 84 83 54 / 06 22 68 24 20", 10, 55);
    doc.setFont("helvetica", "bold");
    doc.text("karine@bo-house.com", 10, 60);
    doc.setFont("helvetica", "normal");

    // Informations du client
    const clientX = 140; // Position à droite


    if (clientIsMoral) {

      doc.text(`${client?.businessName}`, clientX, 40);
      doc.text(client?.businessAdresse || "", clientX, 45);
      doc.text(`${client?.businessCity || ""} ${client?.zipcode || ""}`, clientX, 50);
      doc.text(client?.businessCountry || "", clientX, 55);
    } else {
      doc.text(`${client?.lastName} ${client?.firstName}`, clientX, 40);
      doc.text(client?.adresse || "", clientX, 45);
      doc.text(`${client?.city || ""} ${client?.zipcode || ""}`, clientX, 50);
      doc.text(client?.country || "", clientX, 55);
    }

    // Date générée
    doc.text(getFormattedDate(), clientX, 65);

    // Titre principal centré en gras
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.text("QUITTANCE DE FRAIS", 105, 80, null, null, "center");
    doc.setFont("helvetica", "normal");

    // Tableau des services
    const tableStartY = 90;
    const tableHead = [["DESIGNATION", "QTE", "PRIX UNITAIRE", "TOTAL"]];

    const calculateTotal = () => {
      const values = [formd?.baififf, formd?.security, formd?.rent, formd.exitCleaning];
      return values
        .map(value => parseFloat(value) || 0) // Convertit en nombre et gère les valeurs non définies
        .reduce((acc, curr) => acc + curr, 0); // Additionne les valeurs
    };
    let pmadd = 0;
    if (formd.exitCleaning != undefined && formd.exitCleaning != "") {

      let pm = parseFloat(formd.exitCleaning)
      if (!isNaN(pm) && pm > 0) {
        console.log('exitCleaning', pm)
        pmadd = pm
      }
    }

    // Formatage du total calculé
    const totalFormatted = formatCurrency(calculateTotal());
    let tableBody = [
      [{ content: `LOYER LOCATION ${type} ${property?.nameHouse}\n${property.adresse}, ${property.zipcode} ${property.city}\n${formatDateRange(formd.checkin, formd.checkout)}` }, { content: "1", styles: { halign: "center" } }, { content: formatCurrency(formd?.rent), styles: { halign: "center" } }, { content: formatCurrency(formd?.rent), styles: { halign: "center" } }],
      // [{colSpan:4, content: ""}],
    ];
    if (pmadd > 0) {
      tableBody.push([{ content: "MENAGE DE SORTIE / End of stay cleaning", styles: { fontStyle: 'italic' } },
      { content: "1", styles: { halign: "center" } },
      { content: formatCurrency(pmadd), styles: { halign: "center" } },
      { content: formatCurrency(pmadd), styles: { halign: "center" } }
      ]);
    }

    if (isValid(formd?.baififf)) {
      tableBody.push(["FRAIS HUISSIER / BAIFIFF", { content: "1", styles: { halign: "center" } }, { content: formatCurrency(formd?.baififf), styles: { halign: "center" } }, { content: formatCurrency(formd?.baififf), styles: { halign: "center" } }])
    }

    if (isValid(formd?.security)) {
      tableBody.push(["Caution Remboursable", { content: "1", styles: { halign: "center" } }, { content: formatCurrency(formd?.security), styles: { halign: "center" } }, { content: formatCurrency(formd?.security), styles: { halign: "center" } }],)
    }
    tableBody.push([{ colSpan: 2, content: "" }, { content: "TOTAL  REGLE", styles: { textColor: [255, 0, 0] } }, { content: totalFormatted, styles: { textColor: [255, 0, 0], fillColor: [222, 207, 200], halign: "center" } }]) // Ajout de la ligne pour le total général)

    // [{colSpan:4, content: ""}],



    doc.autoTable({
      startY: tableStartY,
      head: tableHead,
      body: tableBody,
      styles: {
        fontSize: 8,
        halign: "left", // Texte aligné à gauche dans le tableau
        valign: "middle",
        cellPadding: 1,
        lineWidth: 0.1, // Largeur de la bordure
        lineColor: [0, 0, 0], // Couleur de la bordure (noir)
      },
      bodyStyles: {
        lineWidth: 0.1, // Largeur de la bordure des cellules
        lineColor: [0, 0, 0], // Couleur de la bordure (noir)
      },
      headStyles: {
        fillColor: [222, 207, 200],
        textColor: [0, 0, 0],
        fontStyle: "bold",
        halign: "center", // En-tête centré
      },
      alternateRowStyles: {
        fillColor: [255, 255, 255], // Gris clair pour alternance
      },

    });

    // Total général
    const totalY = doc.previousAutoTable.finalY + 10;
    doc.setFontSize(10);
    doc.text("En votre aimable règlement", 10, totalY + 10);
    doc.text("Releve d'identité bancaire (RIB) ", 10, totalY + 20);
    // doc.setFontSize(12);
    // doc.text("TOTAL : 66430,00 €", 10, totalY); 
    doc.autoTable({
      startY: totalY + 25, // Position de départ pour le tableau
      head: [["Banque", "Guichet", "Compte", "Cle RIB"]],
      body: [
        ["18315", "10000", "8008317976", "70"],
        [{ content: "IBAN", colSpan: 3, styles: { fontStyle: 'bold' } }, { content: "BIC", styles: { fontStyle: 'bold' } }],
        [{ content: "FR7618315100000800831797670", colSpan: 3 }, "CEPAFRPP831"],
        [{ content: "Adresse", styles: { fontStyle: 'bold' } }],
        [{ content: "Place du 15 eme Corps", styles: { halign: "left", cellPadding: 0 }, colSpan: 4 }],
        [{ content: "Avenue Augustin Grangeon", styles: { halign: "left", cellPadding: 0 }, colSpan: 4 }],
        [{ content: "83990 Saint-Tropez", styles: { halign: "left", cellPadding: 0 }, colSpan: 4 }],
      ],
      styles: {
        fontSize: 10,
        halign: "center", // Alignement du texte à gauche dans les cellules
        valign: "middle", // Alignement vertical au centre
        cellPadding: 1,
        fillColor: [255, 255, 255],
      },
      headStyles: {
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0], // Couleur du texte de l'en-tête (blanc)
        fontStyle: "bold", // En-tête en gras
        halign: "center", // Texte centré dans l'en-tête
      },

      alternateRowStyles: {
        fillColor: [255, 255, 255],  // Blanc pour alternance
      },
      tableWidth: 100,
      margin: { top: 20 }, // Espacement du haut si nécessaire
    });

    // Informations bancaires
    // const bankInfoY = totalY + 10;


    // Sauvegarder le fichier PDF
    doc.save("quitance.pdf");
  };



  const getDemands = () => {

    firebase.firestore().collection(`demands`)
      .get().then((ls) => {
        let s = [];
        ls.forEach((d) => {
          let e = d.data()
          e.id = d.id;
          if (e?.delete === true) {

          } else {
            s.push({ value: d.id, label: `N° ${e?.origin_id} - ${e?.client?.label} - ${e?.property?.label} (${e?.statut?.label})` })
          }
        })
        setValueListDemande(s);
      }).catch((error) => {
        setL(false);
        var errorMessage = error.message;
        toast.error(errorMessage);
      })
  }

  const getQuestions = () => {
    firebase.firestore().collection(`questions`)
      .where('reservationId', '==', id)
      .get().then((ls) => {
        let s = [];
        ls.forEach((d) => {
          let e = d.data()
          e.id = d.id;
          if (e?.delete === true) {

          } else {
            s.push(e)
          }
        })
        // console.log("logs", s);
        setQuestions(s);

      }).catch((error) => {
        setL(false);
        var errorMessage = error.message;
        toast.error(errorMessage);
      })

  }


  const getLogs = () => {
    firebase.firestore().collection(`etatsdeslieux`)
      .where('booking_id', '==', id)
      .get().then((ls) => {
        let s = [];
        ls.forEach((d) => {
          let e = d.data()
          e.id = d.id;
          if (e?.delete === true) {

          } else {
            s.push(e)
          }
        })
        // console.log("logs", s);
        setLogs(s);

      }).catch((error) => {
        setL(false);
        var errorMessage = error.message;
        toast.error(errorMessage);
      })

  }

  const loadVilla = () => {
    firebase.firestore().collection('properties').get().then((snap) => {
      let s = [];
      snap.forEach((d) => {
        var l = d.data();
        if (l?.delete) {
          // supprimer donc ne pas affiché
        } else {
          const dr = { value: d.id, label: `${l?.nameHouse}`, data: l }
          s.push(dr)
        }

      })
      setVilla(s);
    }).catch((error) => {
      setL(false);
      var errorMessage = error.message;
      toast.error(errorMessage);
    })
  }



  const getClients = () => {
    // get list clients and format
    firebase.firestore().collection('crm').get().then((snap) => {
      let s = [];
      snap.forEach((d) => {
        let e = '';
        let pre = d.data()?.email?.split(',') || []
        pre.forEach((s) => {
          e += `${s}, `;
        })
        const dr = { value: d.id, label: `${d.data()?.lastName} ${d.data()?.firstName}`, email: e, data: d.data() }
        if (d.data()?.delete) { }
        else {
          s.push(dr)
        }
      })
      setClients(s);
    }).catch((error) => {
      setL(false);
      var errorMessage = error.message;
      toast.error(errorMessage);
    })

  }

  useEffect(() => {
    if (id) {
      getClients();
      loadVilla()
      getLogs();
      getQuestions();
      getDemands();
      firebase.firestore().collection('bookings').doc(id).get().then(doc => {
        if (doc) {
          let d = doc.data()
          d.id = doc.id;
          d.email = d?.emails?.join(', ');
          setFrom(d)
          setClientIsMoral(d.clientIsMoral || false)
          setValueClientId(d.client)
          setValueVilla(d.property)
          setValueStatut(d.statut)
          setValueOrigin(d.origin)
          setValueDemande(d.numberDemand);
          setCheckIn(d?.checkin?.toDate() != undefined && d?.checkin?.toDate())
          setDemand_Date(d.demand_date?.toDate() != undefined && d.demand_date?.toDate());
          setCheckOut(d?.checkout?.toDate() != undefined && d?.checkout?.toDate())
          setBooked_Date(d?.booked_date?.toDate() != undefined && d?.booked_date?.toDate());
          setEmails(d?.emails?.join(', '));
          setDisableclientId(d?.client ? true : false) 
          setMenages(d?.menages || []);
          setPropertyIsMoral(d?.propertyIsMoral || false);
        }
      }).catch(err => {
        toast.error('Une erreur s\'est produite. La base de données est actuellement inaccessible, réessayer dans quelques minutes');
      })
    } else {
      toast.error('Une erreur s\'est produite.');
    }
  }, []);

  const validateEmail = (email) => {
    return email.match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
  };

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    event.stopPropagation();

    if (form.checkValidity() === false) {
      toast.error("Champs invalide ou manquant nécessaire");
      return;
    }

    if (l) {
      return;
    }

    var t = formd
    t.checkin = checkIn;
    t.checkout = checkOut;
    t.booked_date = booked_date;
    t._update_At = new Date();
    t.guest = {
      firstName: t?.client?.label.split(' ')[1],
      lastName: t?.client?.label.split(' ')[0]
    }
    let dds = t?.email?.split(',');
    let sd = []
    dds?.forEach(s => {
      if (validateEmail(s?.trim())) {
        sd.push(s?.trim());
      }
    })
    t.emails = sd;
    // console.log('t', t) 
    setValidated(true);
    setL(true);
    let al = t.email
    // delete t.email;
    delete t.id
    if (t.booked_date === undefined) delete t.booked_date;
    t.propertyIsMoral = propertyIsMoral;
    try {
      firebase.firestore().collection('bookings').doc(id).update(t).then(async () => {
        console.log("Document successfully written!");
        toast.success("Réservation modifié avec succès");


        // navigate('/bookings');  
        setL(false);
      }).catch((error) => {
        setL(false);
        var errorMessage = error.message;
        toast.error(errorMessage);
        t.email = al
      })
    } catch (error) {
      setL(false);
      t.email = al
      var errorMessage = error.message;
      toast.error(errorMessage);
    }
  };


  const handleChange = e => {
    let d = { ...formd };
    console.log(e.target.name, e.target?.checked, e.target?.value);
    if (e.target.name === "is_owner") {
      d[e.target.name] = e.target.checked;
      setIs_Owner(e.target.checked)
    } else {
      if (e.target.name === "type") {
        d[e.target.name] = e.target.value === "moral" ? "moral" : "physique";
        setMoral(e.target.value === "moral")
      } else {
        d[e.target.name] = e.target.value;
        if (e.target.name === "email") {
          setEmails(e.target.value)
        }
      }
    }
    setFrom(d);
  };

  const newEtatlieu = () => {
    if (logs.length > 0) {
      toast.warning('Un état des lieux d\'entrée existe pour cette réservation');
      return
    }
    let d = {
      _create_At: new Date(),
      _update_At: new Date(),
      with: formd,
      booking_id: id,
      property: formd?.property,
      client: formd?.client,
      pieces: [],
      comment: '',
      checkin: formd?.checkin,
      checkout: formd?.checkout,
      type: { value: 'in', label: 'Entrée' },
      statut: { value: 'created', label: 'En cours' }
    }
    // check if etat des lieux de sortie du même pid
    firebase.firestore().collection('etatsdeslieux')
      .orderBy("_update_At", "desc")
      .get().then((snap) => {
        let s = [];
        snap.forEach((d) => {
          var l = d.data();
          l.id = d.id;
          if (l.statut?.value === 'confirmed' && l.type.value === 'out' && l.property.value === formd?.property.value) {
            s.push(l);
          }
        })
        if (s.length > 0) {
          toast.warn('Création à partir d\'un état des lieux de sortie en cours, chargement ... ')
          // old finish etat des lieux
          let a = s[0];
          d.pieces = a.pieces;
          d.comment = a.comment
          firebase.firestore().collection('etatsdeslieux').add(d).then((doc) => {
            toast.success('créer, redirection en cours')
            navigate('/etatsdeslieux/edit/' + doc.id)
          }).catch(() => {
            toast.error('Réessayer, un problème est survenu')
          })
        } else {
          // new
          toast.warn('Création en cours, chargement ... ')

          // return;


          firebase.firestore().collection('etatsdeslieux').add(d).then((doc) => {
            toast.success('créer, redirection en cours')
            navigate('/etatsdeslieux/edit/' + doc.id)
          }).catch(() => {
            toast.error('Réessayer, un problème est survenu')
          })
        }

      }).catch((err) => {
        console.log(err)
        toast.warn('Création en cours, chargement ... ')

        // return;
        firebase.firestore().collection('etatsdeslieux').add(d).then((doc) => {
          toast.success('créer, redirection en cours')
          navigate('/etatsdeslieux/edit/' + doc.id)
        }).catch(() => {
          toast.error('Réessayer, un problème est survenu')
        })
      })


  }

  const delIt = async (id) => {
    setL(true);
    try {
      firebase.firestore().collection('etatsdeslieux').doc(id)
        .update({ delete: true }).then((snap) => {
          toast.success("Suppression effectué");
          getLogs();
          setL(false);
        })
    } catch (err) {
      setL(false);
      // eslint-disable-next-line no-console
      console.log(err);
      toast.error("Une erreur s'est produite");
    }
  };


  const del = (id) => {
    if (confirm(`Êtes vous certain de vouloir supprimer l'état des lieux?`)) {
      delIt(id);
    }
  }

  const columnsQuestion = [
    {
      accessor: 'Date',
      Header: 'Date des réponses',
      headerProps: { className: 'text-900' },
      Cell: rowData => {
        const { _createAt } = rowData.row.original
        return (<>{_createAt?.toDate !== undefined && _createAt?.toDate !== undefined && (
          <small className="has-text-grey is-abbr-like">
            {useFormatDate(_createAt?.toDate(), {
              day: 'numeric',
              weekday: 'short',
              year: 'numeric',
              month: 'short',
            })}
          </small>
        )}
        </>)
      }
    },
    {
      accessor: 'action',
      Header: 'Action',
      headerProps: { className: 'text-900' },
      Cell: rowData => {
        const { id } = rowData.row.original
        return (<>

          <IconButton target='_blank' href={`/visualisation-reponses/${id}`}
            variant="falcon-default"
            size="sm"
            icon="eye"
            transform="shrink-3"
            className='me-2'
          >
            <span className="d-none d-sm-inline-block ms-1"></span>
          </IconButton>
        </>
        )
      }
    }
  ]

  const columns = [
    {
      accessor: 'type',
      Header: 'type',
      Cell: ({ row }) => (
        <>
          <span>{row.original.type?.label}</span>
        </>
      )
    },
    {
      accessor: 'statut',
      Header: 'Status',
      Cell: ({ row }) => (
        <>
          <span>{row.original.statut?.label}</span>
        </>
      )
    },
    {
      accessor: 'Date',
      Header: 'Date checkin - checkout',
      headerProps: { className: 'text-900' },
      Cell: rowData => {
        const { checkin, checkout } = rowData.row.original
        return (<>{checkin?.toDate !== undefined && checkout?.toDate !== undefined && (
          <small className="has-text-grey is-abbr-like">
            {useFormatDate(checkin?.toDate(), {
              day: 'numeric',
              weekday: 'short',
              year: 'numeric',
              month: 'short',
            })} au {useFormatDate(checkout?.toDate(), {
              day: 'numeric',
              weekday: 'short',
              year: 'numeric',
              month: 'short',
            })}
          </small>
        )}
        </>)
      }
    },
    {
      accessor: 'action',
      Header: 'Action',
      headerProps: { className: 'text-900' },
      Cell: rowData => {
        const { email, id } = rowData.row.original
        return (<>

          <IconButton target='_blank' href={`/etatsdeslieux/edit/${id}`}
            variant="falcon-default"
            size="sm"
            icon="edit"
            transform="shrink-3"
            className='me-2'
          >
            <span className="d-none d-sm-inline-block ms-1"></span>
          </IconButton>


          <IconButton onClick={() => {
            del(id);
          }}
            variant="falcon-danger"
            size="sm"
            icon="trash"
            transform="shrink-3"
            className='me-2'
          >
            <span className="d-none d-sm-inline-block ms-1"></span>
          </IconButton>
        </>
        )
      }
    }
  ]

  function QuestionTable() {
    if (l) {
      return <p>Chargement...</p>
    }

    return (<AdvanceTableWrapper
      columns={columnsQuestion}
      data={questions}
      sortable
      pagination
      perPage={205}>
      <AdvanceTable
        table
        headerClassName="bg-200 text-nowrap align-middle"
        rowClassName="align-middle white-space-nowrap"
        tableProps={{
          bordered: true,
          striped: true,
          className: 'fs--1 mb-0 overflow-hidden'
        }}
      />
      <div className="mt-3">
        <AdvanceTableFooter
          rowCount={questions.length}
          table
          rowInfo
          navButtons
          rowsPerPageSelection
        />
      </div>
    </AdvanceTableWrapper>)
  }

  function LogTable() {
    if (l) {
      return <p>Chargement...</p>
    }

    return (<AdvanceTableWrapper
      columns={columns}
      data={logs}
      sortable
      pagination
      perPage={205}>
      <AdvanceTable
        table
        headerClassName="bg-200 text-nowrap align-middle"
        rowClassName="align-middle white-space-nowrap"
        tableProps={{
          bordered: true,
          striped: true,
          className: 'fs--1 mb-0 overflow-hidden'
        }}
      />
      <div className="mt-3">
        <AdvanceTableFooter
          rowCount={logs.length}
          table
          rowInfo
          navButtons
          rowsPerPageSelection
        />
      </div>
    </AdvanceTableWrapper>)
  }
  const [preSendEmail, setPreSendEmail] = useState(false)

  const testSendEmail = async () => {
    const emailss = firebase.auth().currentUser.email;
    const sendEmail = firebase.functions().httpsCallable('testSendEmail');
    try {
      setPreSendEmail(true)
      const result = await sendEmail({ id: id, email: emailss });
      console.log("result", result)
      if (result.data && result.data?.success) {
      alert('Email envoyé avec succès');
      } else {
        alert('Les données de checkout / checkin ainsi que la date de la réservation ne sont pas valides pour envoyer un rappel, modifié les données pour correspondre a un type de mail de rappel. Important veuillez enregistrer a chaque modification avant de cliquer sur simuler');
        console.log('result.data', result.data)
      }
      setPreSendEmail(false)
    } catch (error) {
      alert(error)
      setPreSendEmail(false)
      console.error('error', error)
    }
  }

  return (<>



    <FalconComponentCard>
      <FalconComponentCard.Header title={`Edition de la réservation - ${id}`} light={false} noPreview={true} />
      <Col xs={8} sm="auto" className="text-start ps-0 mb-3" style={{ marginLeft: 20 }}>

        <div id="orders-actions">
          <Button
            className="me-2"
            disabled={preSendEmail}
            variant="primary" // Style Bootstrap
            onClick={testSendEmail} // Appelle la fonction testSendEmail au clic
          >
            {preSendEmail ? 'Chargement ...' : 'Simulation (RELANCE DE PAIEMENT)'}
          </Button>
          <IconButton
            target="_blank"
            href={`/comptabilite/${id}`}
            variant="falcon-default"
            size="sm"
            icon="folder-open"
            transform="shrink-3"
            className="me-2"
          >
            <span className="d-none d-sm-inline-block ms-1">
              Voir/Ajouter des fichiers{' '}
              {formd.files?.length > 0 && (
                <p>
                  {formd.files.length} fichier
                  {formd.files.length > 1 && '(s)'}
                </p>
              )}
            </span>
          </IconButton>

        </div>
      </Col>



      <FalconComponentCard.Body >
        {
          formd?.client ? (
            <Form noValidate validated={validated} onSubmit={handleSubmit}>

              <Row className="mb-3">
                <Form.Group as={Col} md="5" controlId="bookingorder">
                  <Form.Label>Client (requis)</Form.Label>
                  <Select
                    required
                    closeMenuOnSelect={false}
                    options={clients}
                    placeholder={clients.length === 0 ? 'Chargement...' : 'Choisir le client...'}
                    classNamePrefix="react-select"
                    value={valueClientId}
                    isDisabled={disabledClientId}
                    onChange={value => {
                      let d = formd;
                      d['client'] = value;
                      setFrom(d);
                      if (valueClientId?.value !== value.value) {
                        // si changement de client on efface email et on réinit
                        let f = formd
                        f['email'] = undefined;
                        setFrom(f);
                        setEmails('')
                      }
                      setValueClientId(value)
                      if (formd['email'] === undefined) {
                        let id = value.value
                        clients.forEach(d => {
                          if (d.value === id) {
                            let f = formd
                            f['email'] = d.email
                            setFrom(f);
                            setEmails(d.email)
                          }
                        })
                      }

                    }
                    }
                  />
                  {formd && formd.client && <p><a href={`/crm/edit/${formd?.client?.value}`} target='_blank'>Voir le client</a></p>}
                  {formd && formd.client === undefined && <p><a href={`#`} onClick={() => setShowModal(true)}  >Nouveau client</a></p>}
                  
                  {formd && formd.client && clients.find((d) => d.value === formd.client.value)?.data?.type === 'moral' && clients.find((d) => d.value === formd.client.value)?.data?.companies != undefined && clients.find((d) => d.value === formd.client.value)?.data?.companies != null && clients.find((d) => d.value === formd.client.value)?.data?.companies.length > 0 && (
                    <Form.Check
                      type="checkbox"
                      id="custom-checkbox"
                      checked={clientIsMoral}
                      label={`Client professionnel (${clients.find((d) => d.value === formd.client.value)?.data?.companies[0]?.businessName})`}
                      onChange={(e) => {
                        let f = formd
                        f['clientIsMoral'] = e.target.checked
                        setFrom(f);
                        setClientIsMoral(e.target.checked)
                      }}
                    />
                  )}

                </Form.Group>


                <Form.Group as={Col} md="5" controlId="villa">
                  <Form.Label>Propriété (requis)</Form.Label>
                  <Select
                    closeMenuOnSelect={false}
                    required
                    options={villas}
                    placeholder='Choisir la villa...'
                    classNamePrefix="react-select"
                    value={valueVilla}
                    onChange={value => {
                      setValueVilla(value)
                      let d = formd;
                      d['property'] = value;
                      setFrom(d);
                    }}
                  />
                  {formd && formd.property && formd.property.value && clients.find((c) => c.value === villas.find(s => s.value === formd.property.value).data.ownerId).data?.type === 'moral' && (

                    <Form.Check
                      type="checkbox"
                      id="custom-checkbox"
                      checked={propertyIsMoral}
                      label={`Facturation professionnel`}
                      onChange={(e) => {
                        let f = formd
                        f['propertyIsModal'] = e.target.checked
                        setFrom(f);
                        setPropertyIsMoral(e.target.checked)
                      }}
                    />
                  )}

                </Form.Group>
              </Row>

              <Row className="mb-3">
                <Form.Group as={Col} md="5" controlId="bookingorder">
                  <Form.Label>Status de la réservation (requis)</Form.Label>
                  <Select
                    closeMenuOnSelect={false}
                    required
                    options={[
                      { value: 'canceled', label: 'Annuler' },
                      // { value: 'created', label: 'En cours' },
                      { value: 'confirmed', label: 'Confirmé' },
                      // { value: 'pay_attented', label: 'En attente de paiement' },
                    ]}
                    placeholder='Choisir le status...'
                    classNamePrefix="react-select"
                    value={valueStatut}
                    onChange={value => {
                      setValueStatut(value)

                      let d = formd;
                      d['statut'] = value;
                      setFrom(d);

                    }}
                  />
                  {valueStatut?.value === 'confirmed' && (<Form.Label><a href='#' onClick={newEtatlieu}>Créer un état des lieux</a></Form.Label>)}

                </Form.Group>
                <Form.Group as={Col} md="5" controlId="bookingorder">
                  <Form.Label>Origine de la réservation</Form.Label>
                  <Select
                    options={[
                      { value: 'direct', label: 'Direct' },
                      { value: 'airbnb', label: 'AirBnb' },
                      { value: 'abritel', label: 'Abritel' },
                      { value: 'tripadvisor', label: 'Tripadvisor' },
                      { value: 'locasun', label: 'Locasun' },
                      { value: 'expedia', label: 'Expedia' },
                      { value: 'homeToGo', label: 'HomeToGo' },
                      { value: 'kayak', label: 'Kayak' },
                      { value: 'homerez', label: 'Homerez' },
                      { value: 'booking', label: 'Booking' },
                      { value: 'website', label: 'Site Internet' },
                      { value: 'partner', label: 'Partenaire' },
                    ]}
                    placeholder="Choisir l'origine..."
                    classNamePrefix="react-select"
                    value={valueOrigin}
                    onChange={value => {
                      setValueOrigin(value)


                      let d = formd;
                      d['origin'] = value;
                      setFrom(d);

                    }}
                  />
                </Form.Group>

                <Form.Group as={Col} md="4" controlId="originid">
                  <Form.Label>Numéro de réservation interne (id origin)</Form.Label>
                  <Form.Control
                    type="text"
                    value={formd.origin_id}
                    name="origin_id"
                    onChange={handleChange}
                    placeholder="Identifiant interne"
                  />
                </Form.Group>


                <Form.Group as={Col} md="4" controlId="originid">
                  <Form.Label>Numéro de commande (aibnb, booking, ...)</Form.Label>
                  <Form.Control
                    type="text"
                    value={formd.number_booking}
                    name="number_booking"
                    onChange={handleChange}
                    placeholder="Numéro de commande..."
                  />
                </Form.Group>


                <Form.Group as={Col} md="4" controlId="adultNbr">
                  <Form.Label>Nombre total d'adulte (requis)</Form.Label>
                  <Form.Control
                    required
                    type="number"
                    value={formd.adultNbr}
                    name="adultNbr"
                    onChange={handleChange}
                    placeholder="Nombre total d'adulte"
                    min={1}
                  />
                </Form.Group>


                <Form.Group as={Col} md="4" controlId="kidsNbr">
                  <Form.Label>Nombre total d'enfant</Form.Label>
                  <Form.Control
                    type="number"
                    name="kidsNbr"
                    value={formd.kidsNbr}
                    onChange={handleChange}
                    placeholder="Nombre total d'enfant"
                    min={0}
                  />
                </Form.Group>


                <Form.Group as={Col} md="4" controlId="roomsNbr">
                  <Form.Label>Nombre total de chambre</Form.Label>
                  <Form.Control
                    type="number"
                    name="roomsNbr"
                    value={formd.roomsNbr}
                    onChange={handleChange}
                    placeholder="Nombre total de chambre"
                    min={0}
                  />
                </Form.Group>



                <Form.Group as={Col} md="10" controlId="email">
                  <Form.Label>Email (requis)</Form.Label>
                  <Form.Control
                    type="text"
                    name="email"
                    value={emails}
                    onChange={handleChange}
                    placeholder="Email du client "
                    required
                  />

                  <Form.Text className="text-warning fs--1">
                    Séparer par une virgule (ex: email@bohouse.com, email2@bohouse.com)
                  </Form.Text>
                </Form.Group>

                <Form.Group as={Col} md="3" controlId={`ScheduleStartDate`}>
                  <Form.Label>Check-in (requis)</Form.Label>

                  <DatePicker
                    showTimeSelect
                    dateFormat="dd/MM/yyyy HH:ss"
                    selected={checkIn}
                    startDate={checkIn}
                    endDate={checkOut}
                    timeFormat="p"
                    required
                    selectsStart
                    onChange={newDate => {
                      let d = formd;
                      d['checkin'] = newDate;
                      setFrom(d)
                      setCheckIn(newDate)
                    }}
                    customInput={
                      <CustomDateInput
                        formControlProps={{
                          placeholder: 'jj/mm/yy',
                          //     ...register(`ScheduleStartDate${index}`)
                        }}
                      />
                    }
                  />
                </Form.Group>


                <Form.Group as={Col} md="3" controlId={`ScheduleEndDate`}>
                  <Form.Label>Check-out</Form.Label>

                  <DatePicker
                    selected={checkOut}
                    showTimeSelect
                    minDate={checkIn}
                    selectsEnd
                    startDate={checkIn}
                    endDate={checkOut}
                    dateFormat="dd/MM/yyyy HH:ss"
                    onChange={newDate => {
                      let d = formd;
                      d['checkout'] = newDate;
                      setFrom(d)
                      setCheckOut(newDate)
                    }}
                    customInput={
                      <CustomDateInput
                        formControlProps={{
                          placeholder: 'jj/mm/yy',
                          //     ...register(`ScheduleStartDate${index}`)
                        }}
                      />
                    }
                  />
                </Form.Group>
                <hr className="mt-3" />
                <Row className="mb-3">
                  <Row>
                    <Col xs={8} sm="auto" className="text-start ps-0 mb-3" style={{ marginLeft: 20 }}>
                      <div id="orders-actions">

                        {/* <Badge bg="danger" style={{ marginRight: 15 }}>Nouveau</Badge> */}
                        <IconButton
                          onClick={generatePDFQuittance}
                          variant="falcon-default"
                          size="sm"
                          icon="file-invoice-dollar"
                          transform="shrink-3"
                          className="me-2"
                        >
                          <span className="d-none d-sm-inline-block ms-1">Quittance</span>
                        </IconButton>

                        <IconButton
                          disabled={formd?.acompte === undefined || formd?.acompte === 0 || formd?.acompte === '' || formd?.acompte === '0'}
                          onClick={generatePDFcall_for_funds_ACOMPTE}
                          variant="falcon-default"
                          size="sm"
                          icon="file-signature"
                          transform="shrink-3"
                          className="me-2"
                        >
                          <span className="d-none d-sm-inline-block ms-1">Appel de fonds (acompte)</span>
                        </IconButton>

                        <IconButton
                          onClick={generatePDFcall_for_funds}
                          variant="falcon-default"
                          size="sm"
                          icon="file-signature"
                          transform="shrink-3"
                          className="me-2"
                        >
                          <span className="d-none d-sm-inline-block ms-1">Appel de fonds (solde)</span>
                        </IconButton>


                        <IconButton
                          onClick={generatePDFInvoice}
                          variant="falcon-default"
                          size="sm"
                          icon="file-invoice"
                          transform="shrink-3"
                          className="me-2"
                        >
                          <span className="d-none d-sm-inline-block ms-1"> propriétaire</span>
                        </IconButton>

                      </div>
                    </Col>
                  </Row>
                  <Form.Group as={Col} lg={3} controlId="accompte">
                    <Form.Label>ACOMPTE (€)</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Acompte"
                      value={formd.acompte}
                      name="acompte"
                      onChange={(e) => {
                        // Permet uniquement les chiffres, le point et la virgule
                        const value = e.target.value.replace(/[^0-9.,]/g, '');
                        // Remplace le point par une virgule
                        const sanitizedValue = value.replace('.', ',');
                        // Ne permet qu'une seule virgule
                        const finalValue = sanitizedValue.replace(/(,.*),/g, '$1');
                        handleChange({
                          target: {
                            name: 'acompte',
                            value: finalValue
                          }
                        });
                      }}
                    />
                  </Form.Group>
                  <Form.Group as={Col} lg={3} controlId="rent">
                    <Form.Label>LOYER LOCATION (€)</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Loyer"
                      value={formd.rent}
                      name="rent"
                      onChange={(e) => {
                        // Permet uniquement les chiffres, le point et la virgule
                        const value = e.target.value.replace(/[^0-9.,]/g, '');
                        // Remplace le point par une virgule
                        const sanitizedValue = value.replace('.', ',');
                        // Ne permet qu'une seule virgule
                        const finalValue = sanitizedValue.replace(/(,.*),/g, '$1');
                        handleChange({
                          target: {
                            name: 'rent',
                            value: finalValue
                          }
                        });
                      }}
                    />
                  </Form.Group>

                  <Form.Group as={Col} lg={3} controlId="baififf">
                    <Form.Label>FRAIS HUISSIER (€)</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Frais Huissier"
                      value={formd.baififf}
                      name="baififf"
                      onChange={(e) => {
                        // Permet uniquement les chiffres, le point et la virgule
                        const value = e.target.value.replace(/[^0-9.,]/g, '');
                        // Remplace le point par une virgule
                        const sanitizedValue = value.replace('.', ',');
                        // Ne permet qu'une seule virgule
                        const finalValue = sanitizedValue.replace(/(,.*),/g, '$1');
                        handleChange({
                          target: {
                            name: 'baififf',
                            value: finalValue
                          }
                        });
                      }}
                    />
                  </Form.Group>

                  <Form.Group as={Col} lg={3} controlId="security">
                    <Form.Label>Caution Remboursable (€)</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Caution Remboursable"
                      value={formd.security}
                      name="security"
                      onChange={(e) => {
                        // Permet uniquement les chiffres, le point et la virgule
                        const value = e.target.value.replace(/[^0-9.,]/g, '');
                        // Remplace le point par une virgule
                        const sanitizedValue = value.replace('.', ',');
                        // Ne permet qu'une seule virgule
                        const finalValue = sanitizedValue.replace(/(,.*),/g, '$1');
                        handleChange({
                          target: {
                            name: 'security',
                            value: finalValue
                          }
                        });
                      }}
                    />
                  </Form.Group>


                  <Form.Group as={Col} lg={3} controlId="cleaningStay">
                    <Form.Label>Nettoyage pendant le séjour (€)</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Nettoyage pendant le séjour"
                      value={formd.cleaningStay}
                      name="cleaningStay"
                      onChange={(e) => {
                        // Permet uniquement les chiffres, le point et la virgule
                        const value = e.target.value.replace(/[^0-9.,]/g, '');
                        // Remplace le point par une virgule
                        const sanitizedValue = value.replace('.', ',');
                        // Ne permet qu'une seule virgule
                        const finalValue = sanitizedValue.replace(/(,.*),/g, '$1');
                        handleChange({
                          target: {
                            name: 'cleaningStay',
                            value: finalValue
                          }
                        });
                      }}
                    />
                  </Form.Group>


                  <Form.Group as={Col} lg={3} controlId="security">
                    <Form.Label>Nettoyage de sortie (€)</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Nettoyage de sortie"
                      value={formd.exitCleaning}
                      name="exitCleaning"
                      onChange={(e) => {
                        // Permet uniquement les chiffres, le point et la virgule
                        const value = e.target.value.replace(/[^0-9.,]/g, '');
                        // Remplace le point par une virgule
                        const sanitizedValue = value.replace('.', ',');
                        // Ne permet qu'une seule virgule
                        const finalValue = sanitizedValue.replace(/(,.*),/g, '$1');
                        handleChange({
                          target: {
                            name: 'exitCleaning',
                            value: finalValue
                          }
                        });
                      }}
                    />
                  </Form.Group>

                  <Form.Group as={Col} lg={3} controlId="agencefee">
                    <Form.Label>Frais d'agence HT (€)</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Frais d'agence"
                      value={formd.agencefee}
                      name="agencefee"
                      onChange={(e) => {
                        // Permet uniquement les chiffres, le point et la virgule
                        const value = e.target.value.replace(/[^0-9.,]/g, '');
                        // Remplace le point par une virgule
                        const sanitizedValue = value.replace('.', ',');
                        // Ne permet qu'une seule virgule
                        const finalValue = sanitizedValue.replace(/(,.*),/g, '$1');
                        handleChange({
                          target: {
                            name: 'agencefee',
                            value: finalValue
                          }
                        });
                      }}
                    />
                  </Form.Group>



                  <Form.Group as={Col} lg={3} controlId="numberInvoice">
                    <Form.Label>Numéro de facture</Form.Label>
                    <Form.Control
                      type="number"
                      placeholder="Numéro de facture"
                      value={formd.numberInvoice}
                      name="numberInvoice"
                      onChange={handleChange}
                    />
                  </Form.Group>

                  <Form.Group as={Col} md="3" controlId="total_pay">
                    <Form.Label>Prix total payée (en €)</Form.Label>
                    <Form.Control
                      type="text"
                      value={formd.total_pay}
                      name="total_pay"
                      onChange={(e) => {
                        // Permet uniquement les chiffres, le point et la virgule
                        const value = e.target.value.replace(/[^0-9.,]/g, '');
                        // Remplace le point par une virgule
                        const sanitizedValue = value.replace('.', ',');
                        // Ne permet qu'une seule virgule
                        const finalValue = sanitizedValue.replace(/(,.*),/g, '$1');
                        handleChange({
                          target: {
                            name: 'total_pay',
                            value: finalValue
                          }
                        });
                      }}
                      placeholder="Tarif total de la réservation (ex: 590.90)"
                    />
                  </Form.Group>


                </Row>

                <hr className="mt-3" />


                <Form.Group as={Col} md="3" controlId={`booked_date`}>
                  <Form.Label>Date de la réservation</Form.Label>

                  <DatePicker
                    selected={booked_date}
                    dateFormat="dd/MM/yyyy"
                    onChange={newDate => {
                      let d = formd;
                      d['booked_date'] = newDate;
                      setFrom(d)
                      setBooked_Date(newDate)
                    }}
                    customInput={
                      <CustomDateInput
                        formControlProps={{
                          placeholder: 'jj/mm/yy',
                          //     ...register(`ScheduleStartDate${index}`)
                        }}
                      />
                    }
                  />
                </Form.Group>
                <hr className="mt-3" />

                {/* <Form.Label>Information sur la demande</Form.Label>  */}

                <Row className="mb-3">
                  <Form.Group as={Col} md="5" controlId="bookingorder">
                    <Form.Label>Numéro de demande</Form.Label>
                    <Select
                      closeMenuOnSelect={false}
                      options={valueListDemande
                        // { value: '1', label: 'N° 3401 - John Doe - Alma' },   
                      }
                      placeholder='Choisir la demande lié...'
                      classNamePrefix="react-select"
                      value={valueDemande}
                      onChange={value => {
                        setValueDemande(value)

                        let d = formd;
                        d['numberDemand'] = value;
                        setFrom(d);

                      }}
                    />
                    {
                      valueDemande?.value && (<p><a href={`/demand/edit/${valueDemande.value}`} target="_blank">Afficher la demande sélectionnée</a></p>
                      )
                    }

                  </Form.Group>

                  <Form.Group as={Col} md="5" controlId="demand_date">
                    <Form.Label> ou Date de la demande</Form.Label>
                    <DatePicker
                      selected={demand_date}
                      dateFormat="dd/MM/yyyy"
                      onChange={newDate => {
                        let d = formd;
                        d['demand_date'] = newDate;
                        setFrom(d)
                        setDemand_Date(newDate)
                      }}
                      customInput={
                        <CustomDateInput
                          formControlProps={{
                            placeholder: 'jj/mm/yy',
                            //     ...register(`ScheduleStartDate${index}`)
                          }}
                        />
                      }
                    />
                  </Form.Group>
                </Row>
                <hr className="mt-3" />
                <Row className="mb-3">
                  <Form.Label>Services de ménage</Form.Label>
                  {
                    menages?.map((menage, index) => {
                      return (<Row className="mb-3">


                        <Form.Group as={Col} md="3" className="mb-3">
                          <Form.Label>Titre</Form.Label>
                          <Form.Control
                            name={`serviceTitle_${index}`}
                            placeholder="Titre"
                            value={menage.title}
                            disabled={formd?.canEdit === false}
                            onChange={(e) => {
                              let o = [...menages];
                              let m = { ...menage };
                              m.title = e.target.value
                              o[index] = m;
                              setMenages(o);
                              let d = { ...formd };
                              d['menages'] = o;
                              setFrom(d);
                            }}
                          />
                        </Form.Group>
                        {/* Champ de Date de début */}
                        <Form.Group as={Col} md="3" className="mb-3">
                          <Form.Label>Date de début</Form.Label>
                          <Form.Control
                            type="datetime-local"
                            name={`startDate_${index}`}
                            value={menage.startDate}
                            disabled={formd?.canEdit === false}
                            onChange={(e) => {
                              let o = [...menages];
                              let m = { ...menage };
                              m.startDate = e.target.value;
                              o[index] = m;
                              setMenages(o);
                              let d = { ...formd };
                              d['menages'] = o;
                              setFrom(d);
                            }}
                          />
                        </Form.Group>

                        {/* Champ de Date de fin */}
                        <Form.Group as={Col} md="3" className="mb-3">
                          <Form.Label>Date de fin</Form.Label>
                          <Form.Control
                            type="datetime-local"
                            name={`endDate_${index}`}
                            value={menage.endDate}
                            disabled={formd?.canEdit === false}
                            onChange={(e) => {
                              let o = [...menages];
                              let m = { ...menage };

                              // Si la date de fin est avant la date de début, on ne fait rien
                              if (new Date(e.target.value) < new Date(m.startDate)) {
                                // Vous pouvez ajouter un message d'erreur ici si vous le souhaitez
                                alert("La date de fin ne peut pas être avant la date de début.");
                                return;
                              }

                              m.endDate = e.target.value;
                              o[index] = m;
                              setMenages(o);
                              let d = { ...formd };
                              d['menages'] = o;
                              setFrom(d);
                            }}
                          />
                        </Form.Group>

                        {formd?.canEdit !== false && (

                          <IconButton as={Col} md="1" onClick={() => {
                            let arr = menages;
                            arr.splice(index, 1);
                            setMenages(arr);
                            let d = { ...formd };
                            d['menages'] = arr;
                            setFrom(d);
                          }}
                            variant="falcon-danger"
                            size="sm"
                            icon="trash"
                            transform="shrink-3"
                            className='me-2'
                            style={{ width: 60, height: 25, marginTop: 35 }}
                          >
                          </IconButton>
                        )}

                      </Row>)
                    })
                  }
                  {formd?.canEdit !== false && (
                    <div>
                      <Flex
                        alignItems="center"
                        className="mb-4 text-primary cursor-pointer fs-0"
                        onClick={() => {
                          let o = [...menages];
                          if (o[o.length - 1]?.title?.trim() !== "") {
                            o.push({ title: "" });
                            setMenages(o);
                          }
                        }}
                      >
                        <span className="circle-dashed">
                          <FontAwesomeIcon icon="plus" />
                        </span>
                        <span className="ms-3">Ajouter une plage de ménage</span>
                      </Flex>
                    </div>)}




                </Row>
                <hr className="mt-3" />
                <Form.Label>Commentaire</Form.Label>
                <Form.Group className="mb-3">

                  <Form.Control as="textarea" name="comment"
                    placeholder="Laisser un commentaire ici"
                    style={{ height: '100px' }}
                    value={formd.comment}
                    onChange={handleChange}
                  />
                </Form.Group>




              </Row>

              <Button type="submit" disabled={l}>{l ? 'Chargement' : 'Modifier'}</Button>
              <Button 
                style={{marginLeft: 20}}
                onClick={() => sendQuestionnaireEmail(id)}
                variant="primary"
                disabled={l} 
              >
                Envoyer le questionnaire avant arrivé ({formd.sensAsk === true ? 'déjà envoyé' : 'non envoyé'})
              </Button>
            
            </Form>) :
            <p>Chargement ...</p>

        }
      </FalconComponentCard.Body>
    </FalconComponentCard>
    <FalconComponentCard>
      <FalconComponentCard.Header title={'Réponses du client'} light={false} noPreview={true} />
      <FalconComponentCard.Body>
        <QuestionTable />
      </FalconComponentCard.Body>
    </FalconComponentCard>
    <FalconComponentCard>
      <FalconComponentCard.Header title={'Etat des lieux'} light={false} noPreview={true} />
      <FalconComponentCard.Body>
        <LogTable />
      </FalconComponentCard.Body>
    </FalconComponentCard>
    {/* Modal d'ajout d'un nouveau client */}
    <Modal fullscreen show={showModal} onHide={() => setShowModal(false)}>
      <Modal.Header closeButton>
        <Modal.Title>Ajouter un nouveau client</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Newucrm canRedirect={false} redirectHere={(value) => {
          let clientsm = clients
          clientsm.push(value);
          setClients(clientsm)
          let d = formd;
          d['client'] = value;
          setFrom(d);
          if (valueClientId?.value !== value.value) {
            // si changement de client on efface email et on réinit
            let f = formd
            f['email'] = undefined;
            setFrom(f);
            setEmails('')
          }
          setValueClientId(value)
          if (formd['email'] === undefined) {
            let id = value.value
            clientsm.forEach(d => {
              if (d.value === id) {
                let f = formd
                f['email'] = d.email
                setFrom(f);
                setEmails(d.email)
              }
            })
          }
          setShowModal(false)
        }} />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => setShowModal(false)}>
          Fermer
        </Button>
      </Modal.Footer>
    </Modal>
  </>
  );
};

export default EditBooking;
